import { APIEnv } from "../../../../interface/baseInterfaces";
import { API_CONSTANTS } from "../../../../constants/search.constanst";
import { Parallax } from "react-scroll-parallax";
import { postData } from "../../../../services/global.service";
import { useState, useEffect, useRef, useContext } from "react";
import "./faq.scss"
import faqData from "./faqData";
import { motion } from "framer-motion";
import { GlobalContext } from "../../../../contexts/GlobalContexts";

const FAQ = () => {
  const [data, setData] = useState([]);
  const [activeFaqCategory, setActiveFaqCategory] = useState("Product & Subscription Basics");
  const [expandedItems, setExpandedItems] = useState<any>({});
  const [displayCategories, setDisplayCategories] = useState(faqData);
  const categoryRefs = useRef<any>({});

  const {globalContext, setGlobalContext}:any = useContext(GlobalContext)
  const updateLoader = (state:boolean) =>{
    setGlobalContext({
      ...globalContext,
      isLoading: state
    })
  }

  useEffect(() => {
    getFaqs(activeFaqCategory);
  }, []);

  const getFaqs = async (category: string) => {
    const params = {
      type: `${category}__premium`,
      subject: "",
      searchtext: "",
      page: 1,
      pageSize: 150,
    };
  
    // Function to clean style and class attributes from HTML strings
    const cleanHtml = (html: string): string => {
      return html
        .replace(/ style="[^"]*"/gi, '')
        .replace(/ class="[^"]*"/gi, '');
    };
  
    try {
      const res = await postData(API_CONSTANTS.FAQ, params, APIEnv.DOT_NET);
      const cleanedData = res?.Data?.lst?.map((item: any) => ({
        ...item,
        details: cleanHtml(item.details),
      }));
      setData(cleanedData);
    } catch (error) {
      console.error("API call failed", error);
    } finally {
      updateLoader(false);
    }
  };
  

  useEffect(() => {
    if (data.length > 0) {
      const transformedData = [
        {
          title: "Taxmann's Learning FAQs",
          items: data.map((item: any) => ({
            question: item.heading,
            answer: item.details
          }))
        }
      ];

      setDisplayCategories(transformedData);
      setExpandedItems({ [`0-0`]: true });
    }
  }, [data]);


  const handleCategoryClick = (category: string) => {
    setActiveFaqCategory(category);
    getFaqs(category); 
    if (categoryRefs.current[category]) {
      categoryRefs.current[category].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const toggleQuestion = (questionId: any, categoryIndex: any) => {
    setExpandedItems((prev: any) => {
      const key = `${categoryIndex}-${questionId}`;
      return {
        ...prev,
        [key]: !prev[key]
      };
    });
  };


  const categoryTitles = faqData.map(category => category.title);

  return (
    <motion.section  initial={{ y: 0, opacity: 1 }}
    whileInView={{ y: 0, opacity: 1 }}
    transition={{ type: "spring", stiffness: 300, damping: 80 }}
    viewport={{once:true, amount: 0.3 }} className="section-screens faqs_answers">
      <Parallax speed={-5}>
        <div className="faq-container">
        <motion.div 
    initial={{ y: -50, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    transition={{ type: "spring", stiffness: 300, damping: 80 }}
    viewport={{once:true, amount: 0.3 }}  className="screens-head"> 
  <h2 className="screens-heading-1"> Frequently Asked Questions </h2>
  {/* <p className="screens-title-h2"> Frequently Asked Questions  </p> */}
</motion.div>

       
<motion.div 
    initial={{ y: -50, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    transition={{ type: "spring", stiffness: 300, damping: 80 }}
    viewport={{once:true, amount: 0.3 }}  className="faq-sections">
            <aside className="faq-sidebar">
              <ul>
                {categoryTitles.map((title, index) => (
                  <li
                    key={index}
                    className={activeFaqCategory === title ? "active" : ""}
                    onClick={() => handleCategoryClick(title)}
                  >
                    {title}
                  </li>
                ))}
              </ul>
            </aside>
            <div className="faq-content">
              <div className="faq-category">
              <motion.div initial={{y: -10, opacity: 0 }}
                          whileInView={{y: 0, opacity: 1 }}
                          transition={{ duration: 2, ease: "easeOut" }} className="faq-category-title-1">{activeFaqCategory}</motion.div>
                {data?.map((item:any, itemIndex:any) => {
                  const isExpanded = expandedItems[`0-${itemIndex}`];
                  return (
                    <motion.div initial={{y: -10, opacity: 0 }}
                          whileInView={{y: 0, opacity: 1 }}
                          transition={{ duration: 2, ease: "easeOut" }}  className="faq-item" key={itemIndex}>
                      <motion.h3 initial={{y: -10, opacity: 0 }}
                          whileInView={{y: 0, opacity: 1 }}
                          transition={{ duration: 2, ease: "easeOut" }}
                        className="faq-question"
                        onClick={() => toggleQuestion(itemIndex, 0)}
                      >
                        {item.heading}
                        <motion.button initial={{y: -10, opacity: 0 }}
                          whileInView={{y: 0, opacity: 1 }}
                          transition={{ duration: 2, ease: "easeOut" }} className="toggle-btn">
                          {isExpanded ? (<img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/pr-faqs-minus.png" alt="Minus"/> 
                           ) : (<img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/pr-faqs-add.png" alt="Add"/> )}
                        </motion.button>
                      </motion.h3>
                       <motion.div initial={{y: -10, opacity: 0 }}
                          whileInView={{y: 0, opacity: 1 }}
                          transition={{ duration: 2, ease: "easeOut" }} 
                          
                        className="faq-answer"
                        style={{ display: isExpanded ? 'block' : 'none' }}
                        dangerouslySetInnerHTML={{ __html: item.details }}
                      >
                      </motion.div>
                    </motion.div>
                  );
                })}
              </div>
              <div className="faq-category-info"> 
Have questions regarding Research, Practice, or Learning? <br/>
Visit our <a href="/faqs" target="_blank"> FAQs Page </a> to get all your answers clarified.    

              </div>

              
            </div>
          </motion.div>
        </div>
      </Parallax>
    </motion.section>
  );
};

export default FAQ;
